import type { IFilters } from '@/types/shared/filters'
import type { PartType } from '../miners/PartType'
import type { ShipmentType } from '../shipments'
import type { RepairRequestSubmissionStatus } from '../repair-requests/RepairRequestSubmission'

export interface ICustomerFilters extends IFilters {
  fragment?: string
  has_work_orders?: boolean
}

export enum RWOOwnership {
  OUR_WORK = 'COMPANY_OWNED',
  OUTSOURCED = 'CUSTOMER_OWNED',
}

export interface IWorkOrderFilters extends IFilters {
  number?: string
  status?: string
  customer_id?: number
  has_inbound_shipments?: boolean
  has_inbound_shipments_with_containers?: boolean
  owner?: RWOOwnership
  type?: string
  has_unread_messages?: boolean
  priority?: string
}

export interface IRepairRequestFilters extends IFilters {
  number: string | undefined
  customer_id: string | undefined
  status: string[] | undefined
}

export interface IRSAFilters extends IFilters {
  customer_id?: number
}

export interface IRSAVersionFilters extends IFilters {
  rsa_number: string
}

export interface IResourceSearchFilters {
  resource: string
  fragment: string
  limit?: number
  work_order_number?: string
  shipment_id?: string
  customer_id?: string
  shipments_with_containers?: boolean
}

export interface IWorkOrderDashboardMinersFilters extends IFilters {
  miner_models: string | undefined
  fragment: string | undefined
  miner_status: string | undefined
  miner_shipping_status: string | undefined
  missing_service: string | undefined
  psu_status: string | undefined
  cb_status: string | undefined
  hb_status: string | undefined
  fan_status: string | undefined
  outbound_container_number?: string
  inbound_container_number?: string
}

export interface IRepairRequestSubmissionFilters extends IFilters {
  status?: RepairRequestSubmissionStatus
  customer_id?: number
}

export interface IShipmentContainersFilters extends IFilters {} // eslint-disable-line @typescript-eslint/no-empty-object-type

export interface IMinerDashboardFilters extends IFilters {
  work_order_number?: string
  models?: string
  customer_id?: number
  part_sn?: string
  fragment?: string
}

export interface ISparePartHistoryFilters extends IFilters {
  start_date?: string
  end_date?: string
}

export interface IMinerHistoryFilters extends IFilters {
  start_date?: string
  end_date?: string
  part_name?: string
}

export interface IContainerDashboardFilters extends IFilters {
  work_order_number?: string
  customer_id?: number
  shipment_id?: number
  type?: string
  kind?: ShipmentType
  status?: string
  fragment?: string
  invoiced?: boolean
  number?: string
}

export interface IShipmentFilters extends IFilters {
  carrier?: string
  status?: string
  type?: string
  fragment?: string
  work_order_number?: string
  customer_id?: number
  has_containers?: boolean
}

export interface ISparePartsDashboardFilters extends IFilters {
  part_type?: string
  status?: string[]
  customer_id?: number
  fragment?: string
  company_owned?: boolean
  site?: string
  work_order_number?: string
  refurbished?: boolean
  archived?: boolean
}

export interface IWorkOrderBillingFilters extends IFilters {
  fragment?: string
}

export interface IInvoiceFilters extends IFilters {
  customer_id?: number
  work_order_number?: string
  status?: string
}

export interface IServiceFilters {
  fragment?: string
  tenant_id?: string
}

export interface IRepairActionFilters {
  part_type?: PartType
  fragment?: string
}

export interface IWorkOrderContainersFilters {
  kind?: ShipmentType
}
